// Create cookie
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// Time Difference
const time_diff = (date) => {
  const curr_date = new Date();
  let diff = Math.abs(date-curr_date);
  // Difference in Days
  diff = Math.floor(diff / (24*60*60*1000));
  return (date-curr_date);
};

// Reject Consent
const reject_consent_val = () => {
  let temp = localStorage.getItem("cookie_popup_time");
  if(temp==null){
    return 10;
  }
  return time_diff(new Date(temp));
};

// Delete cookie
function deleteCookie(cname) {
  const d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=;" + expires + ";path=/";
}

// Read cookie
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// Set cookie consent
function acceptCookieConsent() {
  deleteCookie("user_cookie_consent");
  setCookie("user_cookie_consent", 1, 30);
  document.getElementById("cookieNotice").style.display = "none";
}

function rejectCookieConsent() {
  var currentdate = new Date();
  localStorage.setItem("cookie_popup_time", `${currentdate}`);
  document.getElementById("cookieNotice").style.display = "none";
}

let cookie_consent = getCookie("user_cookie_consent");
let reject_consent = reject_consent_val();

if (cookie_consent != "" || reject_consent<1) {
  document.getElementById("cookieNotice").style.display = "none";
} else {
  document.getElementById("cookieNotice").style.display = "block";
}
